document.addEventListener('DOMContentLoaded', function() {

    function formatCurrency(value) {
        const loc = window.QF?.localization;
      
        const isoCode = loc?.country?.iso_code || 'en-EUR';
        const currencyCode = loc?.currency?.iso_code || 'EUR';
      
        return new Intl.NumberFormat(isoCode, {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    }
          

    const load_btn = document.querySelector(".custom-filter-load-more");
    const infinite_scroll = document.querySelector('.infinite-scroll');
    let products_on_page = document.querySelector('.collection-grid');
    let url = products_on_page.getAttribute('data-next-url');
    const spinner = document.querySelector('.load-more-spinner');

    const load_more = () => {
        spinner.classList.add("show");

        fetch(url)
            .then(function (response) {
                if (response.ok) {
                    return response.text();
                } else {
                    throw new Error('Network response was not ok.');
                }
            })
            .then(function (data) {
                const html = document.createElement('div');
                html.innerHTML = data;

                let links = html.querySelector('.pagination-links').innerHTML;
                document.querySelector('.pagination-links').innerHTML = links;

                let new_grid = html.querySelector('.collection-grid');
                url = new_grid.getAttribute('data-next-url');
                if (url === '') {
                    load_btn.style.display = 'none';
                }
                let new_products = new_grid.querySelectorAll(".product-card, .collection-grid-cta");

                new_products.forEach(new_prod => {
                    products_on_page.append(new_prod);
                });

                // Initialize Swiper for newly added product cards
                initializeProductCardSwipers();

                spinner.classList.remove("show");
            })
            .catch(function (error) {
                window.log(error);
            });
    }

    if (load_btn) {
        if (url === '') {
            load_btn.style.display = 'none';
        }

        load_btn.addEventListener("click", ()=> {
            load_more();
        });

        if (infinite_scroll) {
            // Intersection Observer
            const options = {
                root: null,
                rootMargin: '300px',
                threshold: 0.1
            }

            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        load_more();
                    }
                });
            }, options);

            observer.observe(infinite_scroll);
        }


    }

    const rangeInput = document.querySelectorAll(".range-input input");
    if (rangeInput) {
        const priceInput = document.querySelectorAll(".price-input-show");
        const range = document.querySelector(".slider .progress");
        const minFilterInput = document.querySelector('.min-price-filter');
        const maxFilterInput = document.querySelector('.max-price-filter');
        let priceGap = 1;

        if (maxFilterInput && minFilterInput) {

            if (maxFilterInput.value != "") {
                range.style.left = ((minFilterInput.value / rangeInput[0].max) * 100) + "%";
                range.style.right = 100 - (maxFilterInput.value / rangeInput[1].max) * 100 + "%";
                rangeInput[0].value = minFilterInput.value;
                rangeInput[1].value = maxFilterInput.value;

                priceInput[0].dataset.value = minFilterInput.value;
                priceInput[0].innerHTML = formatCurrency(parseFloat(minFilterInput.value));

                priceInput[1].dataset.value = maxFilterInput.value;
                priceInput[1].innerHTML = formatCurrency(parseFloat(maxFilterInput.value));
            }

            priceInput.forEach(input => {
                input.addEventListener("input", e => {
                    let minPrice = parseInt(priceInput[0].innerHTML);
                    let maxPrice = parseInt(priceInput[1].innerHTML);

                    if ((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max) {
                        if (e.target.className === "input-min") {
                            rangeInput[0].value = minPrice;
                            rangeInput[0].setAttribute("data-term", minPrice);
                            range.style.left = ((minPrice / rangeInput[0].max) * 100) + "%";
                        } else {
                            rangeInput[1].value = maxPrice;
                            maxFilterInput.value = maxVal;
                            range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
                        }
                    }
                });
            });

            rangeInput.forEach(input => {
                input.addEventListener("input", e => {
                    let minVal = parseInt(rangeInput[0].value),
                    maxVal = parseInt(rangeInput[1].value);

                    if ((maxVal - minVal) < priceGap) {
                        if (e.target.className === "range-min") {
                            rangeInput[0].value = maxVal - priceGap
                        } else {
                            rangeInput[1].value = minVal + priceGap;
                        }
                    } else {
                        priceInput[0].dataset.value = minVal;
                        priceInput[0].innerHTML = formatCurrency(minVal);
                        
                        priceInput[1].dataset.value = maxVal;
                        priceInput[1].innerHTML = formatCurrency(maxVal);
                        
                        range.style.left = ((minVal / rangeInput[0].max) * 100) + "%";
                        range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
                        minFilterInput.value = minVal;
                        maxFilterInput.value = maxVal;
                    }
                });
            });
        }
    }

    let custom_filters = document.querySelectorAll(".custom-filter")

    custom_filters.forEach((el)=>{

        let control = el.querySelector(".filter-heading")
        let body = el.querySelector(".filter-body")

        if(control && body){
            control.addEventListener('click', () => {
                if(el.classList.contains("open")){
                    el.classList.remove("open")
                } else {
                    custom_filters.forEach((el)=>{
                        el.classList.remove("open")
                    })
                    el.classList.add("open");
                }
            })
        }
    })

    document.body.addEventListener('click', (e) => {
        if(!e.target.closest(".custom-filter")){
            custom_filters.forEach((el)=>{
                el.classList.remove("open")
            })
        }
    });

    // const reset_filters = document.querySelector('.reset-filter-wrapper');
    const selected_filters_html = document.querySelectorAll('.selected-filter-wrapper *');

    selected_filters_html.forEach(selected => {
        selected.addEventListener('click', () => {
            collection_grid.classList.add("loading")
        })
    })

    // Submit form on input change or button click on mobile
    const filter_inputs = document.querySelectorAll('.filter-container-wrapper select, .filter-container-wrapper input');
    const filter_form = document.querySelector('.filter-container');
    const reset_filter = document.querySelector('#reset-filters');
    const collection_grid = document.querySelector('.collection-grid');
    const apply_filters_btn = document.querySelector('.apply-filters');

    const isMobile = () => window.innerWidth < 992;

    if (apply_filters_btn) {
        apply_filters_btn.addEventListener('click', () => {
            collection_grid.classList.add("loading");
            filter_form.submit();
        });
    }

    filter_inputs.forEach(input => {
        input.addEventListener('change', () => {
            if (!isMobile()) {
                collection_grid.classList.add("loading");
                filter_form.submit();
            }
        });
    });

    if (reset_filter) {
        reset_filter.addEventListener('click', () => {
            collection_grid.classList.add("loading");
        });
    }

    // Initialize Swiper on page load
    initializeProductCardSwipers();

    // Filter sort options
    const hideFiltersBtn = document.querySelector('.hide-filters');
    const mobileFiltersBtn = document.querySelector('.mobile-filters');
    const qfFilterWrapper = document.getElementById('qf-filter-wrapper');

    if (hideFiltersBtn && qfFilterWrapper) {
        const span = hideFiltersBtn.querySelector('span');
        hideFiltersBtn.addEventListener('click', () => {
            qfFilterWrapper.classList.toggle('hide-filters');

            if (span) {
                span.textContent = qfFilterWrapper.classList.contains('hide-filters')
                    ? 'Show Filters'
                    : 'Hide Filters';
            }
        });
    }

    if (mobileFiltersBtn && qfFilterWrapper) {
        mobileFiltersBtn.addEventListener('click', () => {
            qfFilterWrapper.classList.toggle('mobile-filters-open');
        });
    }

    const mobileFilterClose = document.querySelector('.mobile-filter-heading');

    if (mobileFilterClose && qfFilterWrapper) {
        mobileFilterClose.addEventListener('click', () => {
            qfFilterWrapper.classList.remove('mobile-filters-open');
        });
    }

    const sortSelect = document.querySelector('.collection-sort-select');
    const sortOptions = document.querySelector('.sort-options');
    const sortByInput = document.querySelector('#qf-filter-wrapper #SortBy');
    const sortSelected = document.querySelector('.collection-sort-select .sort-selected');

    if (sortSelect && sortOptions && sortSelected) {
        sortSelect.addEventListener('click', (e) => {
            sortOptions.classList.toggle('active');
            e.stopPropagation(); 
        });

        document.querySelectorAll('.sort-options .option').forEach(option => {
            option.addEventListener('click', () => {
                const selectedValue = option.getAttribute('data-value');
                const selectedText = option.textContent;
                const sortByInput = document.querySelector('#qf-filter-wrapper #SortBy');

                if (sortByInput) {
                    sortByInput.value = selectedValue;
                    sortByInput.dispatchEvent(new Event('change'));
                }

                sortSelected.textContent = selectedText;
                sortOptions.classList.remove('active');
            });
        });
    }

    if (sortByInput && sortSelected) {
            const selectedOption = sortByInput.options[sortByInput.selectedIndex];
            if (selectedOption) {
                    sortSelected.textContent = selectedOption.textContent;
            }
    }

    const gridSizeOptions = document.querySelectorAll('.grid-size-option');
    const gridContainers = document.querySelectorAll('.collection-grid, .search-grid');

    if (gridSizeOptions.length && gridContainers.length) {
        gridSizeOptions.forEach(option => {
            option.addEventListener('click', () => {
                const isMobile = option.classList.contains('mobile');
                const category = isMobile ? '.grid-size-option.mobile' : '.grid-size-option.desktop';
                document.querySelectorAll(category).forEach(opt => opt.classList.remove('active'));
                option.classList.add('active');
    
                // Use the data-size value directly for both mobile and desktop
                const dataSize = option.getAttribute('data-size');
                const columns = parseInt(dataSize, 10);
                if (!isNaN(columns)) {
                    gridContainers.forEach(grid => {
                        grid.style.gridTemplateColumns = `repeat(${columns}, 1fr)`;
                    });
                }
            });
        });
    }
})

// Function to initialize Swiper on product cards
function initializeProductCardSwipers() {
    // Select all product card Swiper containers
    const productSwipers = document.querySelectorAll('.productCardSwiper');

    productSwipers.forEach((swiperEl) => {
        if (swiperEl.classList.contains('swiper-initialized')) return; // Prevent duplicate initialization

        new window.swiper(swiperEl, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            nested: true,
            navigation: {
                nextEl: swiperEl.querySelector('.productCardSwiper-next'),
                prevEl: swiperEl.querySelector('.productCardSwiper-prev'),
            },
            lazy: true, // Enable lazy loading
            preloadImages: false,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });

        swiperEl.classList.add('swiper-initialized'); // Mark as initialized
    });
}